export const environment = {
  production: true,
  cdnUrl: 'https://d2yuu33q9f2wq7.cloudfront.net'
};
